import { TrackInfo } from "./dataV2";
export const bSide: TrackInfo[] = [
  {
    title: "N.I.B. - Black Sabbath",
    src: "https://open.spotify.com/embed/track/2GnVuaoKSkB6Xa07l1BBg8?utm_source=generator&theme=0",
    comment:
      "Kicking this off with the vibe from the A-side. A love song from Ozzy with some lyrics I can relate to.",
  },
  {
    title: "Patience - Guns N' Roses",
    src: "https://open.spotify.com/embed/track/1OEoNpiyqBghuEUaT6Je6U?utm_source=generator&theme=0",
    comment: `the title
    speaks for itself. I find this one peaceful and it clams my nerves when I start to overthink the surrounding topic.`,
  },
  {
    title: "This Calling - All that Remains",
    src: "https://open.spotify.com/embed/track/2vH5Fy44mcCDUrUk0XbvfH?utm_source=generator&theme=0",
    comment: `is a track that has more recently popped into my head when I get caught up psychoanalyzing this magnetism I feel towards you.`,
  },
  {
    title: "Rush - Depeche Mode",
    src: "https://open.spotify.com/embed/track/79V6bZgxKO8LXRbS2y8WUB?utm_source=generator&theme=0",
    comment: `I'll keep simple. When I rush, I rush for you.`,
  },
  {
    title: "Black No. 1 - Type O Negative",
    src: "https://open.spotify.com/embed/track/710B9xFjNOisQtKtppZE9p?utm_source=generator&theme=0",
    comment: `of course this made the list. Especially cause the other night when you dyed you hair over here. Also I thing the song suits you.`,
  },
  {
    title: "Sunlight - Modestep",
    src: "https://open.spotify.com/embed/track/1iBOtGRc3RlgxSfpKH8qnB?utm_source=generator&theme=0",
    comment: `reminds of a time from our past and it always puts a smile on my face.`,
  },
  {
    title: "Would You Ever - Skrillex",
    src: "https://open.spotify.com/embed/track/57p8CBvPOxrvyCbn6ttl5r?utm_source=generator&theme=0",
    comment: `kinda sappy but good. The music video helped get this one on the list. It's another track that pops in my head when I daydream.`,
  },
  {
    title: "Walk with Me In Hell - Lamb of God",
    src: "https://open.spotify.com/embed/track/6vjvewW34Y3UiGQtJokGlY?utm_source=generator&theme=0",
    comment: `another title that speaks for itself and a perfect followup to the last track. Naturally I'd have some metal that makes this list.`,
  },
  {
    title: "Dusk in Her Embrace - Cradle of Filth",
    src: "https://open.spotify.com/embed/track/48EgPyGHDxWJe07hHYvl67?utm_source=generator&theme=0",
    comment: `ah
    Cradle of Filth, easily one of my favorite bands. I've always found
    their lyrical content to be very poetic. Which leaves room for
    interpretation. For me, this song speaks to three aspects of love
    that together represent an absolute love. The "real" love, to love
    the person's soul. The sexual love, to love the person's flesh. The eternal love, to love the person unconditionally to no end.`,
  },
  {
    title: "Stinkfist - Tool",
    src: "https://open.spotify.com/embed/track/0pwObEOHolQZSldJ2q1wpy?utm_source=generator&theme=0",
    comment: `the significance of this track has to do with a moment. To keep it simple, it was playing when I had a feeling that overwhelmed me while we were together. Now it associated to moment forever.`,
  },
  {
    title: "Passenger - Deftones",
    src: "https://open.spotify.com/embed/track/7IoK6jZBxY7NMoQPoPXZCF?utm_source=generator&theme=0",
    comment: `I've always like this track, then I started to hear it differently. Whatever this may be, I'm along for the ride. I'm your passenger.`,
  },
  {
    title: "Be My Druidess - Type O Negative",
    src: "https://open.spotify.com/embed/track/1ycz5DvATLtmn2pOU8u38C?utm_source=generator&theme=0",
    comment: ` wouldn't be right with out another Type O Negative track on here.`,
  },
  {
    title: "I Wanna Be Yours - Arctic Monkeys",
    src: "https://open.spotify.com/embed/track/5XeFesFbtLpXzIVDNQP22n?utm_source=generator&theme=0",
    comment: `you
    introduced me to Arctic Monkeys a different track from the same
    album. I found this track because of that and I dedicate it you.`,
  },
];

export const aSide: TrackInfo[] = [
  {
    title: "Christfuck - :Wumpscut:",
    src: "https://open.spotify.com/embed/track/2c3YMLhVxJqIlOdDQHO7yx?utm_source=generator",
    comment: "Should be familiar, in that moment something felt so pure and nothing else existed. You think I'd never done, I just something so rare I have no words for, besides...Amazing!",
  },
  {
    title: "Close To Me - The Cure",
    src: "https://open.spotify.com/embed/track/4xiyq1iRdsxuU1BPUJ490Z?utm_source=generator",
    comment: "Right after dropping this popped in my head, and felt so right. Once I thought you were one that got away and in the moment I had no doubt of the butterflies we shared.",
  },
  {
    title: "Right Here In My Arms",
    src: "https://open.spotify.com/embed/track/4vM4pg4hwediQXCtj21tnI?utm_source=generator",
    comment: "This one came to me wanting and know how much better it would be if you were in my arms, as the weeks passed this came up more.",
  },
  {
    title: "Rx Queen - Deftones",
    src: "https://open.spotify.com/embed/track/6HgrJfzfj9WRBABdussy8z?utm_source=generator",
    comment: "Is it love or lust? It's both, while the lust is getting pushed down the love remains, truth is I'm so addicted to you I need a prescription.",
  },
  {
    title: "Crave you - Flight Facilities",
    src: "https://open.spotify.com/embed/track/5jdGLLEA1e85jy9VYdggoP?utm_source=generator&theme=0",
    comment: "Simple that I do crave you, and see it going away even if you do. Nothing compares to you. You're one of a kind and I enjoy the finer things in life.",
  },
  {
    title: "Pure Morning - Placebo",
    src: "https://open.spotify.com/embed/track/32F0zqsDgqpIEYApk2b8sr?utm_source=generator",
    comment: "A friend with weed is a friend indeed",
  },
  {
    title: "Turns off Pain - :Wumpscut:",
    src: "https://open.spotify.com/embed/track/4FpvUcGsERwfLNMQgbq9aY?utm_source=generator",
    comment: "Some about your presence is soothing, I miss you often. I know relax you too, I wish could have more time together, maybe one day.",
  },
  {
    title: "Chemicals + Circuritry - Grendal",
    src: "https://open.spotify.com/embed/track/5tP1vUcXWLYdRgpDETUZ7X?utm_source=generator",
    comment: "More about my getting fucked up, especially on details that don't matter, but I focus on the little things they stand out the most.",
  },
  {
    title: "Chrome - VNV Nation",
    src: "https://open.spotify.com/embed/track/1hx7w7Csn4m3H9jPw60Ptp?utm_source=generator",
    comment: "I try to reach you, to heal you for yourself. Help you change the path you wander. At times I wonder if I'm driving you away or if I'm really helping you, maybe I should stop talking for the good of myself.",
  },
  {
    title: "I Like You - Device Noize",
    src: "https://open.spotify.com/embed/track/6wDNCdK2oL07EGm3JL4xNz?utm_source=generator",
    comment: "The first track to the fucking list. Meant to split you in two till you can't walk again.",
  },
  {
    title: "Feel Me Fuck Me - Shadow System",
    src: "https://open.spotify.com/embed/track/4CqLfw0hVSG1bTNmoXhESc?utm_source=generator",
    comment: "Many times after hearing this one I kept on hearing it every time I let myself feel alone.",
  },
  {
    title: "Go With The Flow - Queen of the Stone Age",
    src: "https://open.spotify.com/embed/track/45DElIx0dXqUH4A88yQFdE?utm_source=generator",
    comment: "It's was a wonderful day for me personally when I woke up and this was already playing in my head. I had this awakening in my life and a perspective not carried before.",
  },
  {
    title: "3 Libras - A Perfect Circle",
    src: "https://open.spotify.com/embed/track/5kHkaBN8OEQlmXfQkACxSt?utm_source=generator",
    comment: "Hard to really explain this without sounding like I gave up, in a way maybe I did. Or just realized that my true nature. That my fantasies aren't real.",
  },
  {
    title: "Jambi - Tool",
    src: "https://open.spotify.com/embed/track/2gbPu2QNqhnnqtfK3yyeZ0?utm_source=generator",
    comment: "Another one that came to my head related to you. I didn't even know what it was about until I looked at it closer, then it made sense why. I've felt it before.",
  },
];

export const oldASide = `This first side is pretty simple and was easiest to just attach a
playlist/radio station that I find myself often listening to lately.
But for me it sets a mood, a genre you kinda got me hooked on and now
I've come to associate it with you. Either way it's chill, calming,
and relaxing and just reminds me of hanging out with you in our more
recent times.`;
